import { FormInstance } from 'antd';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { FolderStepFormValues } from './folder-create-step';
import { AddAiPages, AiPagesPayload } from '../add-ai-pages/ai-pages';
import { AddFiles, AddFilesPayload } from '../add-files';
import { AddKnowledgeTriggerType } from '../add-knowledge-trigger';
import { AddWebsite, AddWebsitePayload } from '../add-website';

interface Props {
  folderCreateStepForm: FormInstance<FolderStepFormValues>;
  onClose: () => void;
  onNext: (
    payload: AiPagesPayload | AddWebsitePayload | AddFilesPayload,
  ) => Promise<void>;
  actionLoading: boolean;
}
export const FolderContentCreateStep: FC<Props> = ({
  folderCreateStepForm: form,
  onClose,
  onNext,
}) => {
  const contentType = useMemo(() => {
    return form.getFieldValue('contentType');
  }, [form]);
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: <FormattedMessage id="knowledge_base.folder.create.title" />,
        link: '',
      },
    ];
  }, []);

  switch (contentType) {
    case AddKnowledgeTriggerType.AiPages:
      return (
        <AddAiPages
          onClose={onClose}
          onNext={onNext}
          breadcrumbs={breadcrumbs}
        />
      );
    case AddKnowledgeTriggerType.ImportWebsite:
      return (
        <AddWebsite
          apiDocVersion={false}
          onClose={onClose}
          onDone={onNext}
          breadcrumbs={breadcrumbs}
        />
      );
    case AddKnowledgeTriggerType.ApiDoc:
      return (
        <AddWebsite
          apiDocVersion={true}
          onClose={onClose}
          onDone={onNext}
          breadcrumbs={breadcrumbs}
        />
      );
    case AddKnowledgeTriggerType.Files:
      return (
        <AddFiles onClose={onClose} onDone={onNext} breadcrumbs={breadcrumbs} />
      );
    default:
      return <></>;
  }
};
